import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretDown,
  faCaretRight,
  faFile,
  faImage,
  faThumbsUp,
  faThumbsDown,
  faPlus,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import type { VoyagerDetailItem } from '../../models/detail-item';

interface RelationshipsTabProps {
  item: VoyagerDetailItem;
}

const RelationshipsTab: React.FC<RelationshipsTabProps> = ({ item }) => {
  const [structureExpanded, setStructureExpanded] = useState<
    Record<string, boolean>
  >({});

  const relatedItems = item.grp_Collection || item.grp_Catalog || [];

  return (
    <div className="relationships-container">
      {/* Structure Section */}
      <div className="relationships-section">
        <h3 className="relationships-section-title">STRUCTURE</h3>
        <div className="structure-tree">
          {/* Root item with expand/collapse */}
          <div className="structure-item structure-item--root">
            <button
              className="structure-toggle"
              onClick={() =>
                setStructureExpanded((prev) => ({
                  ...prev,
                  [item.id]: !prev[item.id],
                }))
              }
            >
              <FontAwesomeIcon
                icon={structureExpanded[item.id] ? faCaretDown : faCaretRight}
                className="toggle-icon"
              />
            </button>
            <FontAwesomeIcon
              icon={faFile}
              className="structure-icon structure-icon--parent"
            />
            <span className="structure-name">
              {item.name || item.title || item.id}
            </span>
          </div>
          {/* Child item (shown when expanded) */}
          {structureExpanded[item.id] && (
            <div className="structure-item structure-item--child">
              <FontAwesomeIcon
                icon={faFile}
                className="structure-icon structure-icon--child"
              />
              <span className="structure-name structure-name--child">
                {item.name || item.title || item.id}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Used By Section */}
      <div className="relationships-section">
        <h3 className="relationships-section-title">USED BY</h3>
        <div className="used-by-list">
          {relatedItems.length > 0 ? (
            relatedItems.slice(0, 3).map((relatedName: string, idx: number) => (
              <div key={idx} className="used-by-item">
                <div className="used-by-thumbnail">
                  <FontAwesomeIcon
                    icon={faImage}
                    className="thumbnail-placeholder-icon"
                  />
                </div>
                <div className="used-by-content">
                  <h4 className="used-by-title">{relatedName}</h4>
                  <p className="used-by-description">
                    Related item from{' '}
                    {item.grp_Organization?.[0] || 'this collection'}.
                  </p>
                  <p className="used-by-format">
                    <strong>Format:</strong>{' '}
                    {item.format_category || item.format || 'Unknown'}
                  </p>
                  <div className="used-by-votes">
                    <span className="vote-item">
                      <FontAwesomeIcon icon={faThumbsUp} /> {item.likes || 0}
                    </span>
                    <span className="vote-item">
                      <FontAwesomeIcon icon={faThumbsDown} />{' '}
                      {item.dislikes || 0}
                    </span>
                  </div>
                </div>
                <div className="used-by-actions">
                  <button className="action-btn action-btn--add">
                    <FontAwesomeIcon icon={faPlus} /> Add
                  </button>
                  <button className="action-btn action-btn--tools">
                    Tools <FontAwesomeIcon icon={faChevronDown} />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="used-by-empty">
              <p>No related items found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RelationshipsTab;
